export default function Union() {
  return (
    <meta
      http-equiv="refresh"
      content="0;url=https://union.voicemaker.media/"
    />
  );
}
